var _defs, _rect, _path, _line, _line2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerOnCarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b,.h{fill:#fff;}.b,.c,.d{stroke:#e5e5e5;}.b,.c,.d,.f{stroke-linecap:round;}.b,.c,.d,.f,.g,.h{stroke-linejoin:round;stroke-width:2px;}.b,.d,.e,.f,.g,.h{fill-rule:evenodd;}.d{fill:#efefef;}.e,.g{fill:#3c3c46;opacity:0.15;}.f{fill:#89d9fb;}.f,.g,.h{stroke:#3c3c46;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-on-car-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2,21.74a6.31,6.31,0,0,1,6.31-6.31H83.8a6.27,6.27,0,0,1,6.09,6.31v78.92H2V21.74Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.89,
    y1: 35.44,
    x2: 2,
    y2: 35.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.89,
    y1: 72.83,
    x2: 2,
    y2: 72.83
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M89.89,100.65v10.87H7.44A5.39,5.39,0,0,1,2,106.08v-5.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M114.7,37.55H89.89v74H138V72.36L121,41.25A7.27,7.27,0,0,0,114.7,37.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M102.29,72.36H138L123.77,46.25H102.29a1.49,1.49,0,0,0-1.52,1.52V70.83A1.49,1.49,0,0,0,102.29,72.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M113.82,124.57a13.05,13.05,0,1,0-13.05-13.05A13.08,13.08,0,0,0,113.82,124.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M119.88,111.52a6.05,6.05,0,1,1-6.05-6.05A6.07,6.07,0,0,1,119.88,111.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M29.94,124.57a13.05,13.05,0,1,0-13.05-13.05A13.08,13.08,0,0,0,29.94,124.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36,111.52a6.05,6.05,0,1,1-6.05-6.05A6.07,6.07,0,0,1,36,111.52Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M68.33,47.58l-4.56,4.56a12.68,12.68,0,1,0,0,17.93l14.3,14.3A32.9,32.9,0,1,1,49.4,28.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M66.23,43.49,61.67,48a12.68,12.68,0,1,0,0,17.93L76,80.28A32.9,32.9,0,1,1,47.3,24.56Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M46.86,40.87c0,9.09,3.68,15.24,9.64,17.84L66.16,43.6l.07-.11L47.3,35.21v0A37.83,37.83,0,0,0,46.86,40.87Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M46.86,30a32.8,32.8,0,0,0,9.64,23.26l9.67-9.67.07-.07L47.3,24.56v0A33.1,33.1,0,0,0,46.86,30Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 138,
    y1: 83.39,
    x2: 89.89,
    y2: 83.39
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 138,
    y1: 90.49,
    x2: 113.82,
    y2: 90.49
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerOnCarIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-on-car-icon.0841e81df145d35aaca9bb7f74d407d4.svg";
export { ForwardRef as ReactComponent };